import React from 'react';
import { SvgIcon } from '@mui/material';

export default function MenuIconStorage(props) {
  const { iconcolor } = props;
  return (
    <SvgIcon {...props} color="inherit" width="21" height="20" viewBox="0 0 21 20">
      <path d="M16.9058 16.4037H4.15584V8.0877H3.38184V3.5957H17.6178V8.0877H16.9058V16.4037ZM4.55584 16.0037H16.5038V7.6877H17.2158V3.9957H3.78184V7.6877H4.55584V16.0037Z" fill={iconcolor} />
      <path d="M4.99609 7.67383V15.5638H16.0661V7.67383H4.99609ZM12.9501 10.6218H8.05009V9.37783H12.9501V10.6218Z" fill={iconcolor} />
      <path d="M4.22168 4.43359V7.24759H4.91968H16.1417H16.7777V4.43359H4.22168Z" fill="#004C3B" />
    </SvgIcon>
  );
}
